import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import * as typography from '@tds/shared-typography';
import { wordBreak, sup, invertedColor, color, boldFont } from '@tds/shared-typography';
import { spacing } from '@tds/shared-styles';
import { DependentIconSizeContext, safeRest } from '@tds/util-helpers';

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var objectWithoutProperties = _objectWithoutProperties;

var paragraphColor = function paragraphColor(_ref) {
  var invert = _ref.invert;
  return invert ? invertedColor : color;
};

var paragraphInheritColor = function paragraphInheritColor(_ref2) {
  var inheritColor = _ref2.inheritColor;
  return inheritColor ? {
    color: 'inherit'
  } : undefined;
};

var paragraphSize = function paragraphSize(_ref3) {
  var size = _ref3.size;
  return typography[size];
};

var paragraphBold = function paragraphBold(_ref4) {
  var bold = _ref4.bold,
      size = _ref4.size;
  return bold ? boldFont : typography["".concat(size, "Font")];
};

var paragraphAlign = function paragraphAlign(_ref5) {
  var align = _ref5.align;
  return {
    textAlign: align
  };
};

var StyledParagraph = styled.p.withConfig({
  displayName: "Paragraph__StyledParagraph",
  componentId: "efl81j-0"
})(paragraphColor, wordBreak, spacing.noSpacing, paragraphInheritColor, paragraphSize, paragraphBold, paragraphAlign, {
  sup: sup
});
/**
 * Block text as an HTML `<p>` element.
 *
 * @version ./package.json
 */

var Paragraph = function Paragraph(_ref6, context) {
  var size = _ref6.size,
      invert = _ref6.invert,
      children = _ref6.children,
      rest = objectWithoutProperties(_ref6, ["size", "invert", "children"]);

  return React.createElement(DependentIconSizeContext.Provider, {
    value: {
      paragraphSize: size,
      invert: invert
    }
  }, React.createElement(StyledParagraph, _extends_1({}, safeRest(rest), {
    size: size,
    invert: invert,
    inheritColor: context.inheritColor
  }), children));
};

Paragraph.propTypes = {
  /**
   * Embolden paragraph text without conveying any special importance or relevance.
   */
  bold: PropTypes.bool,

  /**
   * The font size.
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /**
   * Content alignment.
   */
  align: PropTypes.oneOf(['left', 'center', 'right']),

  /**
   * Invert the text color to appear light on dark backgrounds.
   */
  invert: PropTypes.bool,

  /**
   * The content. Can be text, other components, or HTML elements.
   */
  children: PropTypes.node.isRequired
};
Paragraph.defaultProps = {
  bold: false,
  size: 'medium',
  align: 'left',
  invert: false
};
Paragraph.contextTypes = {
  inheritColor: PropTypes.bool
};

export default Paragraph;
export { StyledParagraph };
